import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getIconName } from 'utils/documents'
import { getIconName as getActivityIconName } from 'utils/activities'
import {
  ListItem
} from 'components/List'
import KanBoIcon from 'components/KanBoIcon'
import classes from './ActivityContent.module.scss'
import styled from 'styled-components'

const SentTo = styled.div`
  margin-top: -2px;
  margin-bottom: 5px;
  margin-left: 5px;
  font-size: 85%;
  opacity: 0.7;
`

export class ActivityContent extends React.Component {
  static propTypes = {
    fromUser: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    parsedData: PropTypes.object.isRequired,
    tags: PropTypes.array.isRequired,
    currentUser: PropTypes.object.isRequired,
    wasRead: PropTypes.bool,
    actions: PropTypes.element,
    menu: PropTypes.element,
    flash: PropTypes.bool,

    isMessage: PropTypes.bool.isRequired,
  }

  state = {
    previewImage: null
  }

  componentDidMount () {
    this.tryLoadPreviewImage()
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.data.url &&
      this.props.data.url !== prevProps.data.url
    ) {
      this.tryLoadPreviewImage()
    }
  }

  componentWillUnmount () {
    if (this.editTimeout) {
      clearTimeout(this.editTimeout)
    }
    if (this.image) {
      this.image.onload = null
      this.image.onerror = null

      delete this.image
    }
  }

  renderIcon = (action) => {
    if (this.props.isMessage) return null

    const iconName = getActivityIconName(action)

    if (!iconName) return null

    return <KanBoIcon name={iconName} className={classes.actionIcon} />
  }

  tryLoadPreviewImage = () => {
    const { data, tags } = this.props

    if (
      tags &&
      tags.indexOf('documentslistitem') !== -1 &&
      tags.indexOf('remove') === -1
    ) {
      const iconName = getIconName(data.url.substr(data.url.lastIndexOf('/') + 1), false)

      if (iconName === 'file-image-o') {
        this.image = document.createElement('img')
        this.image.onload = this.handleImageLoad
        this.image.onerror = this.handleImageError
        this.image.src = data.url
      } else {
        this.setState({
          previewImage: false
        })
      }
    }
  }

  handleImageLoad = () => {
    this.setState({
      previewImage: true
    })
  }

  handleImageError = () => {
    this.setState({
      previewImage: false
    })
  }

  render () {
    const {
      fromUser,
      currentUser,
      wasRead,
      actions,
      menu,
      flash,

      parsedData,
      isMessage,
    } = this.props
    const {
      previewImage
    } = this.state

    let compClassName = classes.activityContent
    if (
      fromUser.type === 'USER' &&
      fromUser.id === currentUser.id
    ) compClassName += ' ' + classes.currentUser
    if (isMessage) compClassName += ' ' + classes.message
    if (wasRead === false) {
      compClassName += ' list-group-item-warning'
    }
    if (flash) compClassName += ' ' + classes.flash

    return (
      <>
        <ListItem
          className={compClassName}
          menu={menu}
          icon={this.renderIcon(parsedData.action)}
        >
          <span className={classes.content}>
            <span className={classes.text}>
              <FormattedMessage
                id={'ACTIVITY_' + parsedData.action}
                values={parsedData}
              />
            </span>
            {actions &&
              <span className={classes.actions}>
                {actions}
              </span>
            }
          </span>
          {previewImage &&
            <a href={parsedData.url} target='_blank' rel='noopener noreferrer'>
              <img
                className={classes.image}
                src={parsedData.url}
                alt={parsedData.documentsListItemName}
              />
            </a>
          }
        </ListItem>
        {parsedData.action === 'SendEmailFromCard' &&
          <SentTo>
            <FormattedMessage
              id='CARD_COMMENT_SEND_EMAIL_FROM_CARD_SENT_TO'
              values={{
                emails: parsedData.to
              }}
            />
          </SentTo>
        }
      </>
    )
  }
}

export default ActivityContent
